export default {
  SHOW_KEYS: 'showKeys',
  TRUE: 'true',
};
